import React, { ReactNode, useMemo, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import classNames from 'classnames';
import { Collapse } from 'antd-v5';
import './index.scss';
import { useGlobal } from '@/utils/useGlobal';

const OpenIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#757575"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8 11L12 15L16 11" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export type EfAccordionInfoImgType = {
    pc: string;
    pad?: string;
    h5?: string;
    title: string;
    desc?: string;
    grid?: {
        icon?: ReactNode;
        text: string;
    }[];
};

export interface EfAccordionCardsProps {
    className?: string;
    list: EfAccordionInfoImgType[];

    /* moduleTitle 用于埋点 */
    moduleTitle?: string;
}

/**
 * 维护:Hzihhuang（黄子豪）
 *
 * 手风琴「信息图片」组件
 */
const EfAccordionInfoImg: React.FC<EfAccordionCardsProps> = ({ className, list, moduleTitle }) => {
    const { gtm } = useGlobal();
    const [active, setActive] = useState([0]);
    const curItem = useMemo(() => list[active[0]], [active, list]);

    const prefixCls = `ef-accordion-info-img`;

    return (
        <div className={classNames(className, prefixCls)}>
            <div className={`${prefixCls}-container`}>
                <Collapse
                    className={`${prefixCls}-collapse`}
                    accordion
                    activeKey={active}
                    onChange={(key) => {
                        if (key.length === 0) return;
                        setActive(key as unknown as number[]);
                        // @ts-ignore
                        const item = list.find((_i, idx) => idx == key[0]);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'product_details',
                            tab: moduleTitle,
                            button_name: item?.title,
                        });
                    }}
                >
                    {list.map((item, idx) => (
                        <Collapse.Panel header={item.title} showArrow={false} key={idx} extra={OpenIcon}>
                            <div className={`${prefixCls}-desc`}>{item.desc}</div>
                            {item.grid && item.grid?.length > 0 && (
                                <div className={`${prefixCls}-grid`}>
                                    {item?.grid?.map((j, idx2) => (
                                        <div className={`${prefixCls}-grid-item`} key={`${idx}-${idx2}`}>
                                            <div className={`${prefixCls}-grid-icon`}>{j.icon}</div>
                                            <div className={`${prefixCls}-grid-text`}>{j.text}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
            <EfImg className={`${prefixCls}-img`} pc={curItem?.pc} pad={curItem?.pad} h5={curItem?.h5} />
        </div>
    );
};
export default EfAccordionInfoImg;
